import React from "react";

const SerachEventBoxHorizontal = ({
  circle,
  eventItem,
  currentUser,
  customClass = "col-12 col-md-6 p-2",
}) => {
  return (
    <React.Fragment>
      <div key={eventItem.id} className={customClass}>
        <div className="bg-white search-shadow pb-2 rounded h-100">
          <a
            href={"/circle/" + circle.id + "/events/" + eventItem.id}
            className="hov--default"
          >
            <div className="d-flex flex-row bg-gray">
              <div className="col px-0">
                <div className="adjust-box adjust-box-3x2">
                  <img
                    data-src={eventItem.main_image_url_thumb}
                    alt={eventItem.title}
                    className="rounded-top w-100 object-fit-cover adjust-box-inner lazyloaded"
                    onError={(e) => {
                      e.target.src = "/images/ja2/img_noimage.gif";
                    }}
                    src={eventItem.main_image_url_thumb}
                  />
                  {eventItem.is_full ? (
                    <img
                      data-src="/assets2019/img/event/img-event_sold_out.svg"
                      style={{ marginLeft: "0px", height: "60%" }}
                      className="lazyload event-bosyu position-absolute rounded"
                    />
                  ) : eventItem.is_application_ended ? (
                    <img
                      data-src="/assets2019/img/event/img-event_end.svg"
                      style={{ marginLeft: "0px", height: "60%" }}
                      className="lazyload event-bosyu position-absolute rounded"
                    />
                  ) : (
                    ""
                  )}
                  {currentUser && currentUser.id ? (
                    <button
                      className="btn-follow event-list-follow position-absolute"
                      style={{
                        height: "36px",
                        width: "36px",
                        padding: "0",
                        background: "0",
                        border: "none",
                      }}
                      data-event_id={eventItem.id}
                      data-circle_id={circle.id}
                      data-followed="false"
                    >
                      <img src="/assets2019/img/favorite_border_black_24dp.svg" />
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="col-6 px-2">
                <p className="mb-2 mt-2 text-fz-15px text-fw-bold w-100">
                  {eventItem.event_date_formatted}
                </p>
                {!eventItem.is_online ? (
                  <p className="mt-2 mb-0 line-1 icon icon-area mr-1 text-fz-small w-100">
                    <span className="text-fw-bold">
                      {eventItem.countries_pref
                        ? eventItem.countries_pref.name
                        : circle.countries_pref && !circle.special_circle_type
                          ? circle.countries_pref.name
                          : "全国"}
                    </span>
                    <span className="text-gray text-fz-xs ml-1">
                      {eventItem.place}
                    </span>
                  </p>
                ) : (
                  <p className="mt-1 mb-0 line-1 icon icon-online text-fz-small text-fw-bold w-100">
                    オンライン
                  </p>
                )}

                <p className="icon icon-member text-fz-small mt-1 mb-0 w-100">
                  {eventItem.num_of_participants}
                  {eventItem.capacity ? `/${eventItem.capacity}名` : ""}
                </p>

                {eventItem.num_of_participants > 0 ? (
                  <div className="mt-1 w-100">
                    <ul className="d-flex list-unstyled overflow-x-hidden-list mb-0 w-100">
                      {eventItem.valid_events_plans_users.map(function (
                        events_plans_user
                      ) {
                        return (
                          <li key={events_plans_user.id}>
                            <img
                              className="event-member-icon-small lazyloaded"
                              src={`${events_plans_user.user &&
                                events_plans_user.user.avatar_thumb}`}
                            />
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="bg-white mx-3">
              <p
                className={`search-result-event-title mt-2 mb-0 line-2 w-100 ${circle.is_company_owned
                    ? "icon-tunagate_official_sm_before"
                    : ""
                  }`}
              >
                {eventItem.title}
              </p>
              <p className="mb-0 mt-2 line-1 text-fz-xs text-gray">
                サークル：{circle.name}
              </p>
            </div>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SerachEventBoxHorizontal;
